<template>
    <app-primary isMain class="app--main">
        <main-visual />

        <main-section-primary class="secondary lighten-5 grey--text text--darken-4" titWrapClass="tit-wrap--lg">
            <template #subtit>Product story</template>
            <template #tit>{{ $t("main.section1") }}</template>

            <v-row class="row--lg" justify="center">
                <v-col cols="12" md="6" lg="4" data-aos="fade-up" data-aos-delay="100">
                    <main-product-link num="01" href="/product/zero-zang" name="제로장" tag="zeroZang.tag">
                        <template #txt>
                            <span v-html="$t('zeroZang.txt')" />
                        </template>
                    </main-product-link>
                </v-col>
                <v-col cols="12" md="6" lg="4" data-aos="fade-up" data-aos-delay="300">
                    <main-product-link num="02" href="/product/k-zang" name="케이장" tag="kZang.tag">
                        <template #txt>
                            <span v-html="$t('kZang.txt')" />
                        </template>
                    </main-product-link>
                </v-col>
                <v-col cols="12" md="6" lg="4" data-aos="fade-up" data-aos-delay="500">
                    <main-product-link num="03" href="/product/multi-sauce" name="떡볶이의 꿈" tag="DOT.tag">
                        <template #txt>
                            <span v-html="$t('DOT.txt')" />
                        </template>
                    </main-product-link>
                </v-col>
            </v-row>
        </main-section-primary>

        <main-section-primary class="main-section--company" titWrapClass="tit-wrap--lg">
            <template #subtit>Company</template>
            <template #tit>{{ $t("main.section2") }}</template>

            <div class="main-section--company__bg">
                <v-img eager src="/images/main/company-banner.jpg" />
            </div>

            <div>
                <v-row class="row--xl" align="center">
                    <v-col>
                        <v-img eager class="main-section--company__icon" src="/images/main/icon-food.png" data-aos="zoom-out" data-aos-delay="100" />
                        <p class="main-section--company__txt" data-aos="fade-down" data-aos-delay="100">
                            <span v-html="$t('main.story1')" />
                        </p>
                    </v-col>
                    <v-col cols="6" data-aos="fade-right" data-aos-delay="100">
                        <v-img eager class="rounded-lg" src="/images/main/company-01.jpg" />
                    </v-col>
                </v-row>
            </div>

            <div class="pt-60px pt-md-80px pt-lg-100px">
                <v-row class="row--xl" align="center">
                    <v-col cols="6" data-aos="fade-left" data-aos-delay="100">
                        <v-img eager class="rounded-lg" src="/images/main/company-02.jpg" />
                    </v-col>
                    <v-col>
                        <v-img eager class="main-section--company__icon" src="/images/main/icon-tech.png" data-aos="zoom-out" data-aos-delay="100" />
                        <p class="main-section--company__txt" data-aos="fade-down" data-aos-delay="100">
                            <span v-html="$t('main.story2')" />
                        </p>
                    </v-col>
                </v-row>
            </div>

            <div class="pt-60px pt-md-80px pt-lg-100px">
                <v-row class="row--xl" align="center">
                    <v-col data-aos="zoom-out" data-aos-delay="100">
                        <v-img eager class="main-section--company__icon" src="/images/main/icon-global.png" data-aos="zoom-out" data-aos-delay="100" />
                        <p class="main-section--company__txt" data-aos="fade-down" data-aos-delay="100">
                            <span v-html="$t('main.story3')" />
                        </p>
                    </v-col>
                    <v-col cols="6" data-aos="fade-right" data-aos-delay="100">
                        <v-img eager class="rounded-lg" src="/images/main/company-03.jpg" />
                    </v-col>
                </v-row>
            </div>
        </main-section-primary>

        <main-section-tertiary class="main-section--contact">
            <div class="main-section--contact__map">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d799.0581304991767!2d127.99448926963363!3d36.764988972621595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35645fe8b999e3d9%3A0x54f5cd6872669f0b!2z7Lap7LKt67aB64-EIOq0tOyCsOq1sCDsl7Dtko3rqbQg7Zal6rWQ66Gc7ZmN66y46ri4IDc!5e0!3m2!1sko!2skr!4v1704880610936!5m2!1sko!2skr" style="border: 0" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" />
            </div>

            <v-row justify="end">
                <v-col cols="12" lg="6">
                    <v-card rounded class="main-section--contact__card" color="primary" data-aos="fade-up" data-aos-delay="100">
                        <u-tit-subtit class="white--text">Contact Us</u-tit-subtit>
                        <tit-primary>{{ $t("오시는 길") }}</tit-primary>
                        <v-divider class="my-20px my-md-30px my-lg-40px" dark />
                        <txt-primary class="white--text">
                            <div>
                                <v-row class="row--xs">
                                    <v-col cols="12" md="6">
                                        <span class="font-weight-extrabold">Address</span>
                                    </v-col>
                                    <v-col>
                                        <span class="font-weight-bold">{{ $t("addressTxt") }}</span>
                                    </v-col>
                                </v-row>
                            </div>
                            <div class="pt-12px pt-lg-24px">
                                <v-row class="row--xs">
                                    <v-col cols="12" md="6">
                                        <span class="font-weight-extrabold">Tel</span>
                                    </v-col>
                                    <v-col>
                                        <span class="font-weight-bold">{{ $t("010-2345-8499") }}</span>
                                    </v-col>
                                </v-row>
                            </div>
                            <div class="pt-12px pt-lg-24px">
                                <v-row class="row--xs">
                                    <v-col cols="12" md="6">
                                        <span class="font-weight-extrabold">E-mail</span>
                                    </v-col>
                                    <v-col>
                                        <span class="font-weight-bold">kevin1327@naver.com</span>
                                    </v-col>
                                </v-row>
                            </div>
                            <div class="pt-12px pt-lg-24px">
                                <v-row class="row--xs">
                                    <v-col cols="12" md="6">
                                        <span class="font-weight-extrabold">SNS</span>
                                    </v-col>
                                    <v-col>
                                        <v-row class="row--sm">
                                            <v-col cols="auto">
                                                <v-btn href="/" icon x-small>
                                                    <v-img src="/images/main/icon-blog.png" />
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-btn href="/" icon x-small>
                                                    <v-img src="/images/main/icon-instagram.png" />
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </div>
                        </txt-primary>
                        <v-divider class="mt-20px mt-md-30px mt-lg-40px" dark />
                    </v-card>
                </v-col>
            </v-row>
        </main-section-tertiary>
        <!-- <main-section-secondary class="grey lighten-5">
            <template #subtit>123123</template>
            <template #tit>섹션 타이틀</template>
            <template #txt>섹션 타이틀 텍스트</template>

            <v-row align="center" justify="center">
                <v-col cols="auto">
                    <btn-primary to="/guide" class="v-btn--width-fixed">가이드</btn-primary>
                </v-col>
            </v-row>
        </main-section-secondary> -->

        <popup-layer />
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainSectionPrimary from "@/sets/parents/mains/main-section-primary.vue";
import MainSectionSecondary from "@/sets/parents/mains/main-section-secondary.vue";
import MainSectionTertiary from "@/sets/parents/mains/main-section-tertiary.vue";
import MainVisual from "@/sets/styles/mains/main-visual.vue";
import BtnPrimary from "@/components/publish/parents/buttons/btn-primary.vue";
import UTitSubtit from "@/components/publish/styles/typography/u-tit-subtit.vue";
import TitPrimary from "@/components/publish/parents/typography/tit-primary.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";

import MainProductLink from "@/components/client/main/main-product-link.vue";

export default {
    components: {
        AppPrimary,
        PopupLayer,
        MainSectionPrimary,
        MainSectionSecondary,
        MainSectionTertiary,
        MainVisual,
        BtnPrimary,
        UTitSubtit,
        TitPrimary,
        TxtPrimary,

        MainProductLink,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
/* main-section--company */
.main-section--company {
    &__bg {
        position: relative;
        aspect-ratio: 500/102;
        margin-bottom: 40px;
        .v-image {
            position: absolute;
            top: 0;
            left: 50%;
            -webkit-transform: translate(-50%, 0);
            -ms-transform: translate(-50%, 0);
            transform: translate(-50%, 0);
            width: 100vw;
            max-width: 1920px;
            z-index: -1;
        }
    }
    &__icon {
        width: 40px;
        margin-bottom: 12px;
    }
    &__txt {
        font-size: 1.8rem;
    }
}
@media (min-width: 576px) {
    .main-section--company {
        &__txt {
            font-size: 2rem;
        }
    }
}
@media (min-width: 768px) {
    .main-section--company {
        &__bg {
            margin-bottom: 60px;
        }
        &__icon {
            width: 50px;
            margin-bottom: 30px;
        }
        &__txt {
            font-size: 2.4rem;
        }
    }
}
@media (min-width: 1024px) {
    .main-section--company {
        &__bg {
            margin-bottom: 100px;
        }
        &__icon {
            width: 60px;
            margin-bottom: 40px;
        }
        &__txt {
            font-size: 2.8rem;
        }
    }
}
@media (min-width: 1200px) {
    .main-section--company {
        &__bg {
            aspect-ratio: 1200/270;
            margin-bottom: 0;
        }
    }
}

/* main-section--contact */
.main-section--contact {
    position: relative;
    &__map {
        width: 100vw;
        max-width: 100vw;
        height: 400px;
        position: absolute;
        top: var(--grid-gutter);
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        > iframe {
            width: 100%;
            height: 100%;
        }
    }
    &__card {
        margin-top: 300px;
        padding: 40px 24px;
        background: url("/images/main/contact-card-bg.jpg");
        background-size: cover;
    }
}
@media (min-width: 768px) {
    .main-section--contact {
        &__map {
            height: 500px;
        }
        &__card {
            margin-top: 350px;
            padding: 60px;
        }
    }
}
@media (min-width: 1024px) {
    .main-section--contact {
        &__map {
            height: 600px;
            > iframe {
                width: calc(100vw + 296px);
                position: absolute;
                right: 0;
            }
        }
        &__card {
            margin-top: 150px;
            padding: 80px;
        }
    }
}
</style>
